import { useAbility } from '@cast/shared-ability-data-access';

export const usePermitShowAutomatedColumn = () => {
  const permitShowAutomatedColumn = useAbility().can(
    'view',
    'ClusterWorkloadShowAutomatedColumnVPATable'
  );

  return {
    permitShowAutomatedColumn,
  };
};
